import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
import { UserAvatarSizes, } from "./constants";
import { Contrast } from "../../../types/general.types";
const { size, color } = ids || {};
const getContrastStyles = (contrast) => {
    switch (contrast) {
        case Contrast.dark: {
            return css `
        background-color: ${color.contrast.ids_color_contrast_onDark};
        border-color: ${color.contrast.ids_color_contrast_onDark};
      `;
        }
        case Contrast.light: {
            return css `
        background-color: ${color.contrast.ids_color_contrast_onLight};
        border-color: ${color.contrast.ids_color_contrast_onLight};
      `;
        }
        default: {
            return css `
        background-color: ${color.text.heading.ids_color_text_heading_01};
      `;
        }
    }
    return;
};
const getBrandSize = (avatarSize) => {
    switch (avatarSize) {
        case UserAvatarSizes.small:
            return css `
        width: ${size.general.ids_size_general_24x};
        height: ${size.general.ids_size_general_24x};
      `;
        case UserAvatarSizes.medium:
            return css `
        width: ${size.general.ids_size_general_32x};
        height: ${size.general.ids_size_general_32x};
      `;
        case UserAvatarSizes.large:
            return css `
        width: ${size.general.ids_size_general_48x};
        height: ${size.general.ids_size_general_48x};
      `;
        case UserAvatarSizes.huge:
            return css `
        width: ${size.general.ids_size_general_64x};
        height: ${size.general.ids_size_general_64x};
      `;
        default:
            return css `
        width: ${size.general.ids_size_general_48x};
        height: ${size.general.ids_size_general_48x};
      `;
    }
    return;
};
export const UserAvatarContainer = styled.div `
  box-sizing: border-box;
`;
export const StyledUserAvatar = styled.img `
  ${({ avatarSize }) => getBrandSize(avatarSize)}
  ${({ contrast }) => getContrastStyles(contrast)}
  border: ${size.border_width.ids_size_border_small};
  border-radius: ${size.general.ids_size_general_84x};
  object-fit: cover;
`;
export const StyledPlaceHolder = styled.div `
  ${({ avatarSize }) => getBrandSize(avatarSize)}
  ${({ contrast }) => getContrastStyles(contrast)}
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${size.general.ids_size_general_84x};
`;
export const StyledAvatarLetter = styled.p `
  color: ${color.backgrounds.ids_color_bg_variant_01};
  text-transform: uppercase;
  ${(props) => props.contrast === "dark" &&
    css `
      color: ${color.action.neutral.ids_color_action_neutral_variant};
    `};
`;
//# sourceMappingURL=UserAvatar.style.js.map